import { fetchAuthConfigForUnifiedAuth } from './UnifiedAuthConfig';
import { UnifiedAuthView } from './LowLevelUnifiedAuth';
import { useHttpClient } from './HttpClientContext';
import { jsx as _jsx } from "react/jsx-runtime";
export function UnifiedAuthModal({
  portalId,
  authenticatorId,
  appName,
  oAuthScope,
  appId,
  mcp,
  onComplete,
  onCancel,
  introScreen,
  successScreen
}) {
  const http = useHttpClient();
  return /*#__PURE__*/_jsx(UnifiedAuthView, {
    isModal: true,
    isReauth: false,
    portalId: portalId,
    onComplete: result => {
      onComplete(result.secretId);
    },
    onCancel: onCancel,
    introScreen: introScreen,
    successScreen: successScreen,
    fetchAuthConfig: fetchAuthConfigForUnifiedAuth(http, authenticatorId, appName, oAuthScope, mcp, appId)
  });
}
export default UnifiedAuthModal;